import {createApi} from '@reduxjs/toolkit/query/react';
import {ILicensedTitle} from 'models/licensedTitles';
import {IListPayload, IListQuery} from 'models/generic';
import {TProgrammingTypes} from 'helpers/programmingTypes';
import {baseQueryWithAuth} from 'features/baseQueryWithAuth/baseQueryWithAuth';

interface IListLicensedTitleQuery extends Omit<IListQuery, 'search' | 'sort'> {
  title?: string;
  regions?: string[];
  partner?: string;
  sortfield?: number;
  sortdirection?: number;
  programmingType?: TProgrammingTypes;
}

export const licensedTitlesApi = createApi({
  reducerPath: 'licensedTitlesApi',
  tagTypes: ['LicensedTitles'],
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    find: builder.query<IListPayload<ILicensedTitle>, IListLicensedTitleQuery>({
      query: ({
        offset = 0,
        limit = 10,
        sortfield = 1,
        sortdirection = 1,
        title,
        partner,
        regions = [],
        programmingType,
      }) => {
        let url = `rlt/licensed-titles?offset=${offset}&limit=${limit}&sortfield=${sortfield}&sortdirection=${sortdirection}`;

        if (title) {
          url = `${url}&title=${title}`;
        }

        if (partner) {
          url = `${url}&partner=${partner}`;
        }

        if (regions && regions.length > 0) {
          regions.forEach(region => {
            url = `${url}&region=${region}`;
          });
        }

        if (programmingType) {
          url = `${url}&programmingtype=${programmingType as string}`;
        }

        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['LicensedTitles'],
    }),
    findById: builder.query<ILicensedTitle, string>({
      query: (id: string) => ({
        url: `rlt/licensed-titles/${id}`,
        method: 'GET',
      }),
      providesTags: ['LicensedTitles'],
    }),
  }),
});

export const {useFindQuery, useLazyFindQuery, useFindByIdQuery, useLazyFindByIdQuery} = licensedTitlesApi;
